import { Check } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useItemListContext } from './ItemListProvider';
import type { NormalizedItem } from './types';

interface SelectionCheckboxProps {
  item: NormalizedItem;
  className?: string;
}

export function SelectionCheckbox({ item, className }: SelectionCheckboxProps) {
  const { isSelected, toggleItem, permissions } = useItemListContext();
  if (!permissions.canEdit && !permissions.canDelete) return null;

  const selected = isSelected(item.id);

  return (
    <button
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleItem(item); }}
      className={cn(
        'flex h-5 w-5 shrink-0 items-center justify-center rounded-md border transition-all',
        selected
          ? 'border-primary bg-primary text-white shadow-sm'
          : 'border-border/60 bg-card hover:border-primary',
        className,
      )}
      aria-label={selected ? 'Deselect item' : 'Select item'}
    >
      {selected && <Check className="h-3.5 w-3.5" />}
    </button>
  );
}
